module.exports = __webpack_public_path__ + "static/jcb-logo-small-1bc929c2641b17b4ee5ad795af6281b7.svg";